import { StyleSheet, View, Pressable, Text } from 'react-native';
import FontAwesome from "@expo/vector-icons/FontAwesome";

export default function Button({ label, theme, onPress, isDisabled = false }) {
  if (theme === "primary") {
    return (
      <View
      style={[styles.buttonContainer, { borderWidth: 4, borderColor: "#E0CD67", borderRadius: 18 }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: "#fff" }]}
          onPress={onPress}
          disabled={isDisabled}
        >
          <FontAwesome
            name="picture-o"
            size={18}
            color="#25292e"
            style={styles.buttonIcon}
          />
          <Text style={[styles.buttonLabel, { color: "#25292e" }]}>{label}</Text>
        </Pressable>
    </View>
    );
  }

  if (theme === "secondary") {
    
    return (
      <View
      style={[styles.buttonContainer, { borderWidth: 4, borderColor: "#000", borderRadius: 18, alignSelf: 'center' }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: "#fff" }]}
          onPress={onPress}
        >
          {/* <FontAwesome
            name="picture-o"
            size={18}
            color="#25292e"
            style={styles.buttonIcon}
          /> */}
          <Text style={[styles.buttonLabel, { color: "#25292e" }]}>{label}</Text>
        </Pressable>
    </View>
    );
  }

  if (theme === "createaccount") {
    return (
      <View
      style={[styles.buttonContainer, { borderWidth: 4, borderColor: "#E0CD67", borderRadius: 18 }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: "#fff" }]}
          onPress={onPress}
        >
          <FontAwesome
            name="envelope"
            size={18}
            color="#25292e"
            style={styles.buttonIcon}
          />
          <Text style={[styles.buttonLabel, { color: "#25292e" }]}>{label}</Text>
        </Pressable>
    </View>
    );
  }

  if (theme === "saveusername") {
    return (
      <View
      style={[styles.buttonContainer, { borderWidth: 4, borderColor: "#000", borderRadius: 18 }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: "#fff" }]}
          onPress={onPress}
        >
          <FontAwesome
            name="user"
            size={18}
            color="#25292e"
            style={styles.buttonIcon}
          />
          <Text style={[styles.buttonLabel, { color: "#25292e" }]}>{label}</Text>
        </Pressable>
    </View>
    );
  }

  if (theme === "basic") {
    return (
      <View
      style={[styles.buttonContainer, { borderWidth: 4, borderColor: isDisabled ? "#ccc" : "#E0CD67", borderRadius: 18, alignSelf: 'center' }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: isDisabled ? "#f5f5f5" : "#fff" }]}
          onPress={onPress}
          disabled={isDisabled}
        >
          <Text style={[styles.buttonLabel, { color: isDisabled ? "#999" : "#25292e" }]}>{label}</Text>
        </Pressable>
    </View>
    );
  }

  return (
    <View style={styles.buttonContainer}>
        <Pressable style={styles.button} onPress={() => alert('You pressed a button.')}>
          <Text style={styles.buttonLabel}>{label}</Text>
        </Pressable>
      </View>

  );
}


const styles = StyleSheet.create({
  buttonContainer: {
    width: 300,
    height: 68,
    //marginHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 3,
    //backgroundColor: 'red',
  },
  button: {
    borderRadius: 10,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonIcon: {
    paddingRight: 8,
  },
  buttonLabel: {
    color: '#fff',
    fontSize: 16,
  },
});
